import z from "zod";

import { classroomAttachmentSchema } from "./GoogleClassroomClientTypes";

export const classroomAttachmentEntitySchema = classroomAttachmentSchema.extend(
  {
    attachmentId: z.string(),
    createdAt: z.string(),
    teacherLoginHint: z.string().optional(),
  },
);

export type ClassroomAttachmentEntity = z.infer<
  typeof classroomAttachmentEntitySchema
>;

export const userCredentialsEntitySchema = z.object({
  loginHint: z.string(),
  refreshToken: z.string().optional(),
  profilePictureUrl: z.string().optional(),
});

export type UserCredentialsEntity = z.infer<typeof userCredentialsEntitySchema>;

export const classroomCourseWorkEntitySchema = z.object({
  assignmentToken: z.string(),
  courseWorkId: z.string(),
  courseId: z.string(),
  teacherLoginHint: z.string(),
  lessonSlug: z.string(),
  programmeSlug: z.string(),
  unitSlug: z.string(),
  maxPoints: z.number().int().positive(),
  createdAt: z.string(),
});

export type ClassroomCourseWorkEntity = z.infer<
  typeof classroomCourseWorkEntitySchema
>;
